import * as listWholeSalePlanned from './listWholeSalePlanned';

const Reducers = {
  ...listWholeSalePlanned,
};

export default Reducers;
